module.exports = __webpack_public_path__ + "static/media/pdc-logo-small.1b99e5b0.svg";